// extracted by mini-css-extract-plugin
module.exports = {"var-sp-down-2":"0.5rem","varSpDown2":"0.5rem","var-sp-base":"1rem","varSpBase":"1rem","row":"row--e82da","col":"col--91f59"};